import graphql__046d772662702d680ac5 from "./__generated__/ConfigurationViewQuery.graphql.ts";import * as React from "react";
import {connect, ConnectedProps} from "react-redux";
import {Outlet} from "react-router";
import {hideModal, showModal} from "../store/actions";
import BreadcrumbNavigation from "./navigation/BreadcrumbNavigation";
import SecondaryNavigation from "./navigation/SecondaryNavigation";
import {loadQuery, usePreloadedQuery} from "react-relay/hooks";
import type {ConfigurationViewQuery as ConfigurationViewQueryType} from "./__generated__/ConfigurationViewQuery.graphql";
import ConfigurationViewQuery from "./__generated__/ConfigurationViewQuery.graphql";
import ConfigurationContractsViewQuery from "./__generated__/ConfigurationContractsViewQuery.graphql";
import ConfigurationAttributeDefinitionsViewQuery from "./__generated__/ConfigurationAttributeDefinitionsViewQuery.graphql";
import ConfigurationBankAccountsViewQuery from "./__generated__/ConfigurationBankAccountsViewQuery.graphql";
import ConfigurationBankTransactionRulesViewQuery from "./__generated__/ConfigurationBankTransactionRulesViewQuery.graphql";
import {graphql} from "react-relay";
import {useIntl} from "react-intl";

type ConfigurationViewParams = {
    prepared: any
};

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type ConfigurationViewProps = ConfigurationViewParams & ConnectedProps<typeof connector>;

const ConfigurationView: React.FC<ConfigurationViewProps> = (props) => {
    const intl = useIntl();

    usePreloadedQuery<ConfigurationViewQueryType>(
        graphql__046d772662702d680ac5,
        props.prepared.configurationViewQuery,
    );

    const breadcrumbNavigationItems = [
        {label: intl.formatMessage({id: 'breadcrumb.configuration'}), to: '/configuration/contracts'},
    ]

    const secondaryNavigationItems = [
        {
            label: intl.formatMessage({id: 'tab.contracts'}),
            to: '/configuration/contracts'
        },
        {
            label: intl.formatMessage({id: 'tab.attributes'}),
            to: '/configuration/attributes'
        },
        {
            label: intl.formatMessage({id: 'tab.finance'}),
            to: '/configuration/finance'
        },
    ]

    return (
        <>
            <BreadcrumbNavigation items={breadcrumbNavigationItems}/>
            <div className="py-4 md:flex md:items-center md:justify-between">
                <div className="flex-1 min-w-0">
                    <div className="mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
                        <div className="flex items-center space-x-5">
                            <h1 className="text-xl sm:text-2xl font-bold text-gray-900">{intl.formatMessage({id: 'tab.configuration'})}</h1>
                        </div>
                    </div>
                </div>
            </div>
            <SecondaryNavigation items={secondaryNavigationItems}/>
            <div className="mx-auto lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
                <Outlet context={props.prepared}/>
            </div>
        </>
    );
}

export default connector(ConfigurationView);

function prepare_ConfigurationView(params, relayEnvironment) {
    return {
        configurationViewQuery: loadQuery(
            relayEnvironment,
            ConfigurationViewQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
        configurationContractsViewQuery: loadQuery(
            relayEnvironment,
            ConfigurationContractsViewQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
        configurationAttributeDefinitionsViewQuery: loadQuery(
            relayEnvironment,
            ConfigurationAttributeDefinitionsViewQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
        configurationBankAccountsViewQuery: loadQuery(
            relayEnvironment,
            ConfigurationBankAccountsViewQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
        bankTransactionRulesQuery: loadQuery(
            relayEnvironment,
            ConfigurationBankTransactionRulesViewQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
    }
}

export {prepare_ConfigurationView};
